.Container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.FormRow {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.FormColumn {
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
}

.Children {
  flex: 1 1 auto;
}

.Input {
  flex: 1 1 auto;
  min-width: 5ch;
  max-width: 15ch;
}

.Spacer {
  flex: 1;
}
